<template>
  <div>
    <div class="container footer-spacer">
      <h1>Account</h1>
      <!-- edit form column -->
      <div class="personal-info mt-4">
        <form class="form-wrapper" role="form">
          <div class="status-wrapper">
            <span class="status-label">Account Status:</span>
            <a
              disabled
              href="#"
              class="status"
            >{{ getCurrentUser && getCurrentUser.is_paid ? "PRO": "FREE" }}</a>

            <br />
            <!-- Modal Trigger -->
            <!-- <a
              v-if="getCurrentUser && getCurrentUser.is_paid && !getCurrentUser.canceled_at"
              href="#"
              @click="openModal"
              class="cancel-sub"
            >Cancel PRO Subscription</a>
            <a
              v-if="getCurrentUser && getCurrentUser.canceled_at"
              href="#"
              class="cancel-sub"
              disabled
            >PRO Subscription canceled {{ formattedCancelDate }}</a>-->
            <div class="current-email">
              Account Email:
              <span
                class="active-email"
              >{{ !isAuthLoading && getCurrentUser ? getCurrentUser.email : "" }}</span>
            </div>
          </div>
          <!-- <hr /> -->
          <!-- <br /> -->

          <!-- <div class="form-group">
            <label class="control-label"></label>
            <div class>
              <button class="btn btn-save">Save Changes</button>
              <button class="btn btn-cancel">Cancel</button>
            </div>
          </div>-->
        </form>
      </div>
    </div>
    <!-- Sweet Modal -->
    <!-- <sweet-modal ref="modal" title="Cancel ReplyNinja PRO">
      <div class="cancel-text">Will you deny your Ninja destiny and cancel your PRO subscription?</div>
      <button
        class="btn btn-cancel btn-modal"
        @click="cancelSubscription"
        :disabled="isAuthLoading"
      >{{ isAuthLoading ? 'Cancelling...' : 'Yes, cancel PRO' }}</button>
      <button class="btn btn-save btn-modal" @click="closeModal">NO, Go Back!</button>
    </sweet-modal>-->
  </div>
</template>

<script>
import moment from "moment";
// import { SweetModal } from "sweet-modal-vue";
import { mapGetters } from "vuex";
import { AUTH_CANCEL_SUBSCRIPTION } from "@/store/types";

export default {
  computed: {
    ...mapGetters(["getCurrentUser", "isAuthLoading"]),
    formattedCancelDate() {
      if (this.getCurrentUser && this.getCurrentUser.canceled_at) {
        return moment.unix(this.getCurrentUser.canceled_at).fromNow();
      }
    }
  },
  components: {
    // SweetModal
  },
  data() {
    return {
      activeUser: {}
    };
  },
  mounted() {
    /*
    if (this.getCurrentUser) {
      this.activeUser = this.getCurrentUser;
    }
    */
  },
  methods: {
    // openModal() {
    //   this.$refs.modal.open();
    // },
    // closeModal() {
    //   this.$refs.modal.close();
    // },
    // cancelSubscription() {
    //   this.$store.dispatch(AUTH_CANCEL_SUBSCRIPTION).then(resp => {
    //     this.$refs.modal.close();
    //   });
    // }
  }
};
</script>

<style lang="scss" scoped>
.container {
  margin-top: 50px;
}

.footer-spacer {
  margin-bottom: 150px;
}

.form-wrapper {
  background-color: #1e2229;
  border-radius: 10px;
  padding: 20px 20px;
  text-align: left;
  margin: 0 10px 10px;
}

.personal-info {
  min-width: 100%;
}

.control-label {
  font-family: "Open Sans";
  color: #fff;
  font-weight: bold;
}

.form-control {
  border: 2px solid white;
  border-radius: 4px;
  margin: 0 auto;
  font-family: "Open Sans";
  width: 100%;
  margin-top: 10px;
  margin-bottom: 15px;
  font-size: 15px;
  box-sizing: border-box;
  padding: 6px;
}

input:focus {
  outline: none !important;
  border: 2px solid #00c853;
}

.cancel-text {
  margin: 30px 0px 50px;
  font-weight: bold;
  color: white;
}

.btn {
  padding: 6px;
  margin: 0 15px 0 0;
  cursor: pointer;
}

.btn-modal {
  float: right;
}

.btn-save {
  border: 2px solid #00c853;
  font-weight: 700;
  padding-left: 20px !important;
  padding-right: 20px !important;
  color: white;
  background: #111622;
  &:hover {
    background: darken(#00c853, 5%);
    border: 2px solid darken(#00c853, 5%);
  }
}

.btn-cancel {
  border: 2px solid red;
  font-weight: 700;
  padding-left: 20px !important;
  padding-right: 20px !important;
  color: white;
  background: #111622;
  &:hover {
    background: red;
  }
}

.current-email {
  color: white;
  font-weight: bold;
  margin: 20px 0 20px 0;
}

.active-email {
  color: #ddd;
  text-decoration: underline;
  margin-left: 10px;
}

.status-wrapper {
  margin: 20px auto 34px;
}

.status-label {
  color: white;
  font-weight: bold;
  font-size: 20px;
}

.status {
  padding: 5px 14px;
  background-color: #00c853;
  border-radius: 8px;
  color: white;
  font-weight: bold;
  font-size: 20px;
  margin: 15px;
}

.cancel-sub {
  border: 2px solid darken(red, 25%);
  border: 2px solid red;
  border-radius: 5px;
  padding: 5px 20px;
  color: white !important;
  display: inline-block;
  cursor: pointer;
  margin-top: 30px;
  font-size: 16px;
  font-weight: bold;
  transition: all 0.2s ease-in-out;
  &:hover {
    color: white !important;
    border: 2px solid red;
    background: red;
  }
}
</style>